<template>
  <base-section
    id="phd-forum"
    space="0"
  >
    <v-card
      class="mx-auto"
      max-width="100%"
    >
      <v-img
        :src="require(`@/images/phdforumwinner.png`)"
      />

      <v-card-title>
        SERGIO VINAGRERO GUTIERREZ
        <br>
        PhD Forum Winner ETS22
      </v-card-title>

      <v-card-actions>
        <v-btn
          color="primary"
          text
          @click="show1 = !show1"
        >
          Read More
        </v-btn>

        <v-spacer />

        <v-btn
          icon
          @click="show1 = !show1"
        >
          <v-icon>{{ show1 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </v-card-actions>

      <v-expand-transition>
        <div v-show="show1">
          <v-divider />

          <v-card-text>
            <strong>Title</strong>: Memristor-based Security Primitives
            <br>
            <strong>Affiliation</strong>: UGA/CNRS/G-INP/TIMA, Grenoble, France
            <br>
            <strong>Paper Abstract</strong>: Physically Unclonable Functions (PUFs) are a mechanism that exploit intrinsic manufacturing variability introduced in a
            device during the fabrication process to generate a signature, unique to each single device. In order to
            guarantee its security, the generated secret key must be unique from device to device (unclonable),
            and, for a same device, it must be robust with respect to aging and environmental variations
            (reproducible).
            True Random Number Generators (TRNGs) are used to generate random numbers from a physical
            process, rather than a computer program. They are implemented by taking advantage of thermal noise
            or other quantum phenomena and are expected to generate random bits with very high entropy and
            zero correlation. An on-chip TRNG design should occupy small area, give high bit rate, and have low
            power consumption, while assuring un-biased bit streams with high entropy per bit and low (no)
            correlation among them.
            The rapid development of low power, high density, high performance SoCs has pushed the embedded
            memories to their limits and opened the field to the development of emerging memory technologies.
            The Resistive Random Access Memory (ReRAM) has emerged as a promising choice for embedded
            memories due to its reduced read/write latency and high CMOS integration capability. Inner properties
            of ReRAMs make them suitable for the implementation of basic security primitives such Physically
            Unclonable Functions (PUFs) and True Random Number Generators (TRNGs). This thesis will explore
            solutions which exploit (i) the high variability affecting the electrical resistance of the resistive device
            to build a robust, unclonable and unpredictable PUF, and (ii) the stochastic nature of the write
            operation in the resistive device to generate randomly distributed numbers.
          </v-card-text>
          <v-card-actions>
            <v-spacer />

            <v-btn
              icon
              @click="show1 = !show1"
            >
              <v-icon>{{ show1 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </v-card-actions>
        </div>
      </v-expand-transition>
    </v-card>
  </base-section>
</template>
<script>
  export default {
    name: 'PhdForum',
    data: () => ({
      show1: false,
    }),
  }
</script>
